import Component from './MapDateRangeFilter';
export default Component;

export const componentName = 'MapDateRangeFilter';
